import { createAsyncAction } from 'typesafe-actions';
import { APIError } from '../../types/errors';
import { GetCallsPayload, GetCallsResponse } from './payload';

export const getCalls = createAsyncAction(
    'GET_CALLS',
    'GET_CALLS_SUCCESSES',
    'GET_CALLS_FAILED',
)<GetCallsPayload, GetCallsResponse, APIError>();